export const PUBLIC_ROUTES = ['/login', '/forgot-password', '/create-password', '/change-password', '/first-login', '/cookie-policy','/privacy-policy','/terms-and-conditions','/modern-slavery-statement'];

export default defineNuxtRouteMiddleware(async (to, from) => {
  // Authentication and permissions checks
  const { isAuthenticated, getToken } = useAuth();

  if (!isAuthenticated.value && !PUBLIC_ROUTES.includes(to.path)) {
    return navigateTo('/login');
  }

  const { hasAllPermissions } = usePermissions();
  const { meta } = to.meta as { meta: { permissions: string[] } };
  if (meta?.permissions && !hasAllPermissions(meta.permissions) && !PUBLIC_ROUTES.includes(to.path)) {
    return showError(createError({ statusCode: 404 }));
  }
});
